export default "__VITE_ASSET__nMmZIQDa__"